import ProductStatusService from './service';

export * from './reqres';

export default ProductStatusService;
